import {
  getAuth,
  RecaptchaVerifier,
  signInWithPhoneNumber
} from 'firebase/auth'
import firebaseConfig from '../../const/firebase'
import { initializeApp } from 'firebase/app'

declare global {
  export interface Window {
    recaptchaVerifier: any
    confirmationResult: any
    grecaptcha: any
  }
}

export const configureCaptcha = () => {
  if (!window.recaptchaVerifier) {
    const auth = getAuth()
    window.recaptchaVerifier = new RecaptchaVerifier(
      'captcha',
      {
        size: 'invisible',
        defaultCountry: 'IN'
      },
      auth
    )
  } else {
    window.recaptchaVerifier.render().then((widgetId: number) => {
      window.grecaptcha.reset(widgetId)
    })
  }
}

export const sendOtp = (phoneNumber: string) => {
  const phone = `+91${phoneNumber}`
  const appVerifier = window.recaptchaVerifier

  const auth = getAuth()
  signInWithPhoneNumber(auth, phone, appVerifier).then((confirmationResult) => {
    window.confirmationResult = confirmationResult
  })
}

export const validateOTP = (
  otp: string,
  successCallback: () => void,
  errorCallback: () => void
) => {
  window.confirmationResult
    .confirm(otp)
    .then(successCallback)
    .catch(errorCallback)
}

const triggerOtpVerification = (phoneNumber: string) => {
  initializeApp(firebaseConfig)
  configureCaptcha()
  sendOtp(phoneNumber)
}

export default triggerOtpVerification
